exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selection-btn[data-v-7a09b968]{border-radius:6px;box-shadow:0 2px 4px 0 rgba(0,0,0,.09);font-family:Open Sans,sans-serif;font-size:12px;font-weight:600;letter-spacing:0;padding:6px 8px 5px!important}", ""]);

// exports
